"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Maybe_1 = require("./Maybe");

var Just =
/** @class */
function (_super) {
  __extends(Just, _super);

  function Just(value) {
    var _this = _super.call(this) || this;

    _this.value = value;
    return _this;
  }

  Just.prototype.getOrElse = function (fn) {
    return this.value;
  };

  Just.prototype.getOrElseValue = function (defaultValue) {
    return this.value;
  };

  Just.prototype.map = function (fn) {
    return new Just(fn(this.value));
  };

  Just.prototype.andThen = function (fn) {
    return fn(this.value);
  };

  Just.prototype.orElse = function (fn) {
    return this;
  };

  Just.prototype.cata = function (matcher) {
    return matcher.Just(this.value);
  };

  Just.prototype.assign = function (k, other) {
    var _this = this;

    var maybe = other instanceof Maybe_1.default ? other : other(this.value);
    return maybe.map(function (b) {
      var _a;

      return __assign({}, Object(_this.value), (_a = {}, _a[k.toString()] = b, _a));
    });
  };

  Just.prototype.do = function (fn) {
    fn(this.value);
    return new Just(this.value);
  };

  Just.prototype.elseDo = function (fn) {
    return this;
  };

  return Just;
}(Maybe_1.default);

exports.Just = Just;

exports.just = function (value) {
  return new Just(value);
};

exports.default = Just;